<template>
  <div class="music" @click="onMusicClick">
    <img
      :src="
        active ? require('@/assets/mic.png') : require('@/assets/mic_step.png')
      "
      alt=""
    >
  </div>
</template>

<script>

export default {
  name: "MUSIC",
  props: {
    active: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onMusicClick() {
      this.$emit('click')
    }
  }
};
</script>

<style lang="scss" scoped>
.music{
    position: fixed;
    right: 20px;
    top: 20px;
    z-index: 9;
    img{
      width: 30px;
      height: 30px;

    }
  }
</style>
